var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clipboard__outer" }, [
    _c(
      "div",
      { staticClass: "clipboard" },
      [
        _c("div", { staticClass: "clipboard__value-outer" }, [
          _c("label", { staticClass: "clipboard__label" }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "clipboard__value",
              attrs: { id: "clipboard-target" }
            },
            [_vm._v(_vm._s(_vm.value))]
          )
        ]),
        _vm._v(" "),
        _c(
          "md-button",
          {
            staticClass: "md-icon-button",
            attrs: {
              id: "clipboard-btn",
              "data-clipboard-target": "#clipboard-target"
            },
            on: { click: _vm.showSuccess }
          },
          [
            _c(
              "md-icon",
              { staticClass: "clipboard__icon md-icon-half-sized" },
              [_vm._v("content_copy")]
            ),
            _vm._v(" "),
            _c("md-tooltip", [_vm._v("Copy")])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e011f50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e011f50","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/fields/ClipboardField.vue
// module id = Jyln
// module chunks = 1